import React from "react";
import { Icon, Modal } from "semantic-ui-react";
import PropTypes from "prop-types";

export default class ModalMessage extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    message: PropTypes.string,
    showLoader: PropTypes.bool,
    size: PropTypes.string,
    closeIcon: PropTypes.bool,
    onClose: PropTypes.func,
    header: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.node),
    config: PropTypes.oneOf(["info", "error", ""])
  };

  defaultProps: {
    size: "mini",
    closeIcon: false,
    actions: [],
    config: ""
  };

  render() {
    const {
      open,
      message,
      showLoader,
      size,
      closeIcon,
      onClose,
      actions,
      header
    } = this.props;
    return (
      <Modal
        open={open}
        dimmer="blurring"
        closeIcon={closeIcon}
        onClose={() => {
          onClose && onClose();
        }}
        size={size}
      >
        {header && <Modal.Header>{header}</Modal.Header>}
        <Modal.Content>
          {showLoader && <Icon loading name="spinner" size="large" />}
          {message}
        </Modal.Content>
        {actions &&
          actions.length > 0 && <Modal.Actions>{actions}</Modal.Actions>}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ModalMessage/index.js